import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Inheritance, InheritanceType } from "../workflow/declarations";
import { OrgChartEntry } from "../v-org-chart/v-org-chart.component";
import { WFType } from "@vierkant-software/types__api";

type DepartmentEntry = OrgChartEntry & { children?: DepartmentEntry[] };
export type FormType = {
};

@Component({
    selector:    "v-workflow-inheritance",
    styleUrls:   ["./workflow-inheritance.component.sass"],
    templateUrl: "./workflow-inheritance.component.haml",
    standalone:  false
})

export class WorkflowInheritanceComponent implements OnChanges {

    @Input() public rootID: string;

    @Input() public departmentNodes: DepartmentEntry[];

    @Input() public workflow: WFType;
    @Input() public inhertiance: Inheritance;
    @Output() public close: EventEmitter<Record<string, InheritanceType>> = new EventEmitter<Record<string, InheritanceType>>();

    public departments: Record<string, DepartmentEntry> = {};
    public form = new FormGroup({});
    public controls: Record<string, FormControl> = {};
    public rootNode: DepartmentEntry;

    public setup() {
        if (!this.workflow || !this.departmentNodes || !this.rootID)
            return;
        this.reset();
        this.departmentNodes.forEach(dep => {
            const depCopy = {...dep};
            const parent = this.departments[dep.parentID];
            if (parent) (parent.children ??= []).push(depCopy);
            this.departments[dep.ID] = depCopy;
            if (this.form.get(dep.ID))
                this.form.get(dep.ID).patchValue(dep.workflows[this.workflow]?.inheritance);
             else
                this.form.addControl(dep.ID, this.controls[dep.ID] = new FormControl(dep.workflows[this.workflow]?.inheritance));
        });

        this.rootNode = this.departments[this.rootID];
    }

    public reset() {
        this.form.reset();
        this.rootNode = null;
        this.departments = {};
        this.controls = {};
    }

    public cancel() {
        this.close.emit(undefined);
        this.onClose();
    }

    public confirm() {
        this.close.emit(this.form.value);
        this.onClose();
    }

    private onClose() {
        this.form.reset();
    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.setup();
    }
}
